import classNames from 'classnames';
import { forwardRef } from 'react';

import Typography from '@mui/material/Typography';

const rootCss = ({ palette, shape, spacing }) => ({
  padding: spacing(0.5, 1.5),
  display: 'inline-block',
  borderRadius: shape.borderRadius,
  textAlign: 'center',
  lineHeight: 1.1,
  '&.root_disabled': {
    backgroundColor: palette.text.disabled,
    color: palette.common.white,
  },
  '&.size_small': {
    padding: '2px 6px',
  },
  '&.color_grey': {
    '&.root_default': {
      color: palette.background.paper,
      backgroundColor: palette.text.secondary,
    },
    '&.root_light': {
      color: palette.text.secondary,
      backgroundColor: palette.background.paper1,
    },
  },
  '&.color_black': {
    '&.root_default': {
      color: palette.background.paper,
      backgroundColor: palette.text.primary,
    },
    '&.root_light': {
      color: palette.text.primary,
      backgroundColor: palette.background.paper1,
    },
  },
  ...palette.mapColors(c => ({
    [`&.color_${c}`]: {
      '&.root_default': {
        color: palette[c].contrastText,
        backgroundColor: palette[c].main,
      },
      '&.root_light': {
        color: palette[c][c === 'yellow' ? 'medium' : 'main'],
        backgroundColor: palette[c].background,
      },
    },
  })),
});

export default forwardRef(function Label(
  {
    className,
    color = 'primary',
    disabled,
    label,
    size = 'medium',
    textVariant = 'overline',
    variant = 'default',
    ...rest
  },
  ref,
) {
  return (
    <Typography
      className={classNames(className, `root_${variant}`, `size_${size}`, {
        [`color_${color}`]: !disabled,
        root_disabled: disabled,
      })}
      css={rootCss}
      ref={ref}
      variant={textVariant}
      {...rest}
    >
      {label}
    </Typography>
  );
});
